import { t } from '../locale';

export default {
    methods: {
        t(...args) {
            return t.apply(this, args);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/iview/src/mixins/locale.js
// module id = 259
// module chunks = 1